<template>
    <div style='display: inline-block; margin: 0; padding: 0'>
        <canvas style='display: block; margin: 0; padding: 0' ref='rulerCanvas' :width='canvasWidth' :height='canvasHeight'/>
    </div>
</template>

<script>

export default {
    // https://stackoverflow.com/questions/40410332/vuejs-access-child-components-data-from-parent
    // https://stackoverflow.com/questions/45478035/start-range-in-v-for-n-in-10-from-zero
    props: {
        itemsCount: {
            type: Number,
            required: true
        },
        startingSide: {
            type: String,
            required: true
        },
        cellPixelSize: {
            type: Number,
            required: true
        },
        lineThicknessPixels: {
            type: Number,
            required: true
        }
    },
    mixins: [],
    components: {
    },
    data() {
        return {
            color: {
                'hex': '#D88080'
            },
            vueCanvas: null,
            linesInterval: 4,
            minimumLabelPixelSize: 4,
            minimumFontPixelSize: 6,
            maximumFontPixelSize: 14,
            minimumFontSpacingPixels: 2
        }
    },
    methods: {
        drawRuler() {
            let initialX = 0
            let initialY = 0
            let xIncrementAmount = 0
            let yIncrementAmount = 0
            let lineWidth = 0
            let lineHeight = 0
            let numberOfLines = Math.floor(this.itemsCount / this.linesInterval)

            if (this.startingSide==='left') {
                initialY = 0
                lineWidth = this.lineThicknessPixels
                lineHeight = this.canvasHeight
                xIncrementAmount = (this.cellPixelSize + this.lineThicknessPixels) * this.linesInterval
                initialX = xIncrementAmount
                yIncrementAmount = 0
            }
            else if (this.startingSide==='right') {
                initialX = this.canvasWidth - this.lineThicknessPixels - ((this.cellPixelSize + this.lineThicknessPixels) * this.linesInterval)
                initialY = 0
                lineWidth = this.lineThicknessPixels
                lineHeight = this.canvasHeight
                xIncrementAmount = -1 * (this.cellPixelSize + this.lineThicknessPixels) * this.linesInterval
                yIncrementAmount = 0
            }
            else if (this.startingSide==='top') {
                initialX = 0
                lineWidth = this.canvasWidth
                lineHeight = this.lineThicknessPixels
                xIncrementAmount = 0
                yIncrementAmount = (this.cellPixelSize + this.lineThicknessPixels) * this.linesInterval
                initialY = yIncrementAmount
            }
            else if (this.startingSide==='bottom') {
                initialX = 0
                initialY = this.canvasHeight - this.lineThicknessPixels - ((this.cellPixelSize + this.lineThicknessPixels) * this.linesInterval)
                lineWidth = this.canvasWidth
                lineHeight = this.lineThicknessPixels
                xIncrementAmount = 0
                yIncrementAmount = -1 * (this.cellPixelSize + this.lineThicknessPixels) * this.linesInterval
            }
            let lineX = initialX
            let lineY = initialY
            let labelTextX = 0
            let labelTextY = 0

            let fontSpacingAmount = Math.floor(this.cellPixelSize / 4)
            if (fontSpacingAmount < this.minimumFontSpacingPixels) {
                fontSpacingAmount = this.minimumFontSpacingPixels
            }

            for (let lineNumber = 0; lineNumber < numberOfLines; lineNumber++) {
                let labelText = ''
                labelText = ((lineNumber + 1) * this.linesInterval) + ''
                let labelTextWidth = this.vueCanvas.measureText(labelText).width
                this.vueCanvas.fillRect(lineX, lineY, lineWidth, lineHeight)

                if (this.cellPixelSize > this.minimumLabelPixelSize) {
                    if (this.startingSide==='left') {
                        labelTextX = lineX - labelTextWidth - fontSpacingAmount
                        labelTextY = lineY + (this.cellPixelSize * 2)
                    }
                    if (this.startingSide==='right') {
                        labelTextX = lineX + fontSpacingAmount
                        labelTextY = lineY + (this.cellPixelSize * 2)
                    }
                    if (this.startingSide==='top') {
                        labelTextX = lineX + fontSpacingAmount
                        labelTextY = lineY - fontSpacingAmount
                    }
                    if (this.startingSide==='bottom') {
                        labelTextX = lineX + fontSpacingAmount
                        labelTextY = lineY + this.cellPixelSize + fontSpacingAmount + 2
                    }
                    this.vueCanvas.fillText(labelText, labelTextX, labelTextY)
                }

                lineX += xIncrementAmount
                lineY += yIncrementAmount
            }
        }
    },

    watch: {
    },

    computed: {
        canvasWidth: function() {
            if (this.startingSide==='left' || this.startingSide==='right') {
                return (this.itemsCount * this.cellPixelSize) + ((this.itemsCount+1) * (this.lineThicknessPixels))
            }
            else {
                return (2 * this.cellPixelSize) + (3 * (this.lineThicknessPixels))
            }
        },
        canvasHeight: function() {
            if (this.startingSide==='top' || this.startingSide==='bottom') {
                return (this.itemsCount * this.cellPixelSize) + ((this.itemsCount+1) * (this.lineThicknessPixels))
            }
            else {
                return (2 * this.cellPixelSize) + (3 * (this.lineThicknessPixels))
            }
        },
        fontPixelSizeStyle: function() {
            let size = this.cellPixelSize + 3
            if (size < this.minimumFontPixelSize) {
                size = this.minimumFontPixelSize
            }
            return size + 'px Arial'
        }
    },
    created() {
    },
    mounted() {
        let c = this.$refs.rulerCanvas
        let ctx = c.getContext('2d')
        ctx.font = this.fontPixelSizeStyle
        ctx.fillStyle = this.color.hex
        this.vueCanvas = ctx
        this.drawRuler()
    },
    updated() {
        let c = this.$refs.rulerCanvas
        let ctx = c.getContext('2d')
        ctx.font = this.fontPixelSizeStyle
        ctx.fillStyle = this.color.hex
        this.vueCanvas = ctx
        this.drawRuler()
    }
}
</script>
